module.exports = __webpack_public_path__ + "media/images/mypage/btn03_ov-2a5dcb3166a22c8c64bdbec46068b38f.gif";